import React from 'react';
import { Tag as AntdTag, TagProps } from 'antd';
import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import { hexToRGB } from 'app/utils';
import get from 'lodash/get';

export type STATUS_TYPE =
  | 'pending'
  | 'pendingAssign'
  | 'waiting'
  | 'waitingQuote'
  | 'waitingAccept'
  | 'waiting for approval'
  | 'rejected'
  | 'scheduledReject'
  | 'scheduled'
  | 'in-progress'
  | 'complete'
  | 'completed'
  | 'cancelled'
  | 'quoteAvailable'
  | 'approved'
  | 'waitingPayment'
  | 'underReview'
  | 'bookingReserved'
  | 'pass'
  | 'cap'
  | 'fail'
  | 'inspectionReleased'
  | 'inspectionReleasedWaiver'
  | any;

export const STATUS = {
  pending: '#B8D819', //Pending Assign (Admin)
  pendingAssign: '#B8D819',
  waitingQuote: '#FFC625',
  quoteAvailable: '#005EFF',
  waiting: '#FFC625', //Waiting to accept (Admin,Inspector)
  waitingAccept: '#FFC625',
  underReview: '#FFC625',
  'waiting for approval': 'FFC625',
  scheduledReject: '#ED4646',
  rejected: '#ED4646', //Reject schedule (Admin,Inspector reject)
  scheduled: '#005EFF', //Scheduled (Admin,Inspector accept)
  'in-progress': '#005EFF', //In-progress(Admin,Inspector) - after check in
  complete: '#1EC000', //Completed(Admin,Inspector) - after submit
  completed: '#1EC000',
  cancelled: '#ED4646',
  approved: '#005EFF',
  waitingPayment: '#FFC625',
  bookingReserved: '#FFC625',
  pass: '#1EC000', //Validate -PASS
  cap: '#ED4646', //Validate -CAP
  fail: '#ED4646', //Validate -Fail,
  inspectionReleased: '#32C832',
  inspectionReleasedWaiver: '#32C832',
  inspectionRejected: '#FF6E58',
  default: '#fff'
};

const JobStatus = styled(AntdTag, {
  shouldForwardProp: (prop) =>
    isPropValid(prop) && prop !== 'status' && prop !== 'alpha'
})`
  border-radius: 6px;
  border: none;
  font-style: normal;
  font-weight: 500;
  padding: 2px 4px;
  line-height: 14px;
  font-size: 10px;
  background: ${(
    props: Partial<
      TagProps & {
        alpha: number;
        status: STATUS_TYPE | any;
      }
    >
  ) =>
    hexToRGB(
      get(STATUS, props.status || 'default', STATUS['default']),
      props?.alpha ?? 0.2
    )};
  color: ${(
    props: Partial<
      TagProps & {
        alpha: number;
        status: STATUS_TYPE | any;
      }
    >
  ) =>
    props.alpha && props?.alpha > 0.8
      ? '#ffff'
      : get(STATUS, props.status || 'default', STATUS['default'])};
`;

export const JOB_STATUS = {
  pending: 'Pending Assign',
  waiting: 'Waiting To Accept',
  waitingAccept: 'Waiting To Accept',
  waitingQuote: 'Waiting To Accept',
  pendingAssign: 'Pending Assign',
  'waiting for approval': 'Waiting For Approval',
  rejected: 'Inspection Rejected ',
  scheduledReject: 'Schedule Rejected',
  scheduled: 'Scheduled',
  inProgress: 'In Progress',
  'in-progress': 'In Progress',
  complete: 'Completed',
  completed: 'Completed',
  cancelled: 'Canceled',
  approved: 'Approved',
  pass: 'Validate -PASS',
  cap: 'Validate -CAP',
  fail: 'Validate -Fail',
  waitingPayment: 'Waiting Payment',
  underReview: 'Under Review',
  bookingReserved: 'Booking Reserved',
  inspectionReleased: 'Inspection Released',
  inspectionReleasedWaiver: 'Inspection Released (Waiver)',
  default: ''
};

export default JobStatus as any;

const StatusLabel = (props: { status: string; className?: any }) => {
  const Labels: Record<any, string> = {
    passed: 'Passed',
    pass: 'Passed',
    rejected: 'Reject',
    pending: 'Pending',
    failed: 'Failed',
    default: '',
    fail: 'Failed'
  };
  return <p className={props.className}>{Labels[props.status as any]}</p>;
};

export const Status = styled(StatusLabel)`
  margin-bottom: -1px;
  font-style: normal;
  font-weight: 500;
  padding: 2px 4px;
  line-height: 14px;
  font-size: 10px;
  color: ${(props: any) => {
    const Colors: Record<any, string> = {
      pending: '#8991A0',
      rejected: '#ED4646',
      failed: '#ED4646',
      passed: '#1EC000',
      pass: '#1EC000',
      default: '',
      fail: '#ED4646'
    };
    return Colors[props.status as any];
  }};
`;
